import { render, staticRenderFns } from "./candidateInfo.vue?vue&type=template&id=6dd0492f&scoped=true"
import script from "./candidateInfo.vue?vue&type=script&lang=js"
export * from "./candidateInfo.vue?vue&type=script&lang=js"
import style0 from "./candidateInfo.vue?vue&type=style&index=0&id=6dd0492f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd0492f",
  null
  
)

export default component.exports